<template>
  <div class="content">
    <!-- 商品表格 -->
    <el-table
      :data="dataList"
      style="width: 100%;overflow-y: scroll;"
      height="calc(100vh - 220px)"
      v-loading="loading"
 
    >
      <el-table-column
        type="index"
        label="序号"
        width="50"
        align="center"
      ></el-table-column>
      <el-table-column label="名称" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.title ? scope.row.title : "暂无" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="配置公众号链接" align="center">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.link"
            placeholder="请输入内容"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="sumbmitBtn(scope.row)"
            >确定修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { selectConfig, updateConfig } from "@/services/config/pageConfig.js";
import { IP } from "@/services/index.js";
export default {
  data() {
    return {
      dataList: [],
      inputTitle: "新增",
      cover: "",
      fileList: [], //上传列表
      action: IP + "/uploadFile/add",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "管理员账号", id: "0" },
        { name: "药店", id: "1" },
        { name: "检测机构", id: "2" },
      ],
      form: {},
      dialogFormVisible: false,
    };
  },
  created() {

    this.selectFun();
  },
  methods: {
    // 查询
    selectFun() {
      selectConfig().then((resp) => {

        this.loading = false;
        this.dataList = resp.data;
      });
    },

    // 表单提交按钮
    sumbmitBtn(row) {
      
      updateConfig(row).then((res) => {
 
        if (res.code == 200) {
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.selectFun();
        } else {
          this.$message({
            type: "info",
            message: "网络错误",
          });
        }
      });
    },
  },
  // 删除
  deleteAdmin(row) {
    this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        console.log(row.id);
        // deleteBanner(row.id).then((resp) => {
        //   console.log(resp);
        //   this.$message({
        //     type: "success",
        //     message: "删除成功!",
        //   });
        //   this.selectFun();
        // });
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
  },
};
</script>

<style>
.content {
  margin: 20px auto;
  width: 96%;
}
</style>
